import React from 'react'
import styled from 'styled-components'
import { ContactIcon, Theme, Tel } from '@pga/pga-component-library'
import theme from '../../Layout/theme'
import { Title } from '../../common/styled'

export const PhoneNumbersWrapped = styled.div`
  margin-right: 175px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  white-space: nowrap;
  a {
    color: ${Theme.colors.lightBlue};
  }
  @media screen and (max-width: 1200px) {
    margin-right: 0px;
    white-space: wrap;
  }
  @media screen and (max-width: 767.98px) {
    padding: 15px 0;
    align-items: flex-start;
    white-space: wrap;
  }
`

const ContactIconStyled = styled(ContactIcon)`
  align-self: flex-start;
  padding: 0 10px 0 0;
  svg path {
    stroke: ${Theme.colors.greyBlue}
  }
  cursor: auto;
`

const textOptions = {
  color: theme.colors.primary,
  pt: '0',
  pl: '0',
  fontSize: '14'
}

export default ({ numbers }) => (
  <PhoneNumbersWrapped>
    <ContactIconStyled />
    <div>
      {numbers.publicMobile && <Title {...textOptions}><Tel phoneNumber={numbers.publicMobile} /> (mobile)</Title>}
      {numbers.publicPhone && <Title {...textOptions}><Tel phoneNumber={numbers.publicPhone} /> (phone)</Title>}
    </div>
  </PhoneNumbersWrapped>
)
